<template>
    <div >
        <v-toolbar class="glass rounded-lg" outlined  >
            <v-toolbar-title>
                Add Course
            </v-toolbar-title>
            <v-spacer/>

            <inertia-link as="v-btn" :href="route('admin.courses.index')" color="primary" depressed>
                Back to Courses
            </inertia-link>
        </v-toolbar>

        <br>
        <form  @submit.prevent="saveCourse">
            <v-card flat class="rounded-lg py-5 px-2"  >
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model="form.title"
                                label="Course Title"
                                :error-messages="$page.props.errors.title"
                                outlined
                                dense
                            />
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-textarea
                                rows="3"
                                v-model="form.preview_text"
                                label="Course Short Description"
                                :error-messages="$page.props.errors.preview_text"
                                outlined
                                dense
                                aria-valuemax="160"
                                counter="160"
                                max="5"
                            />
                        </v-col>
                    </v-row>

                    <br>
                    <h3>Details</h3>
                    <br>
                    <editor
                        v-model="form.details"
                        api-key="14yypo7x0g8259wulfr1f05ehujo1f8l2ktu3qvwxdmhleur"
                        :plugins="myPlugins"
                        :toolbar ="myToolbar"
                        :init="myInit"
                        placeholder="Course Descriptive details"
                    ></editor>
                    <br>


                    <br>
                    <h3>Requirements</h3>
                    <br>
                    <editor
                        v-model="form.requirement"
                        api-key="14yypo7x0g8259wulfr1f05ehujo1f8l2ktu3qvwxdmhleur"
                        :plugins="reqPlugins"
                        :toolbar ="reqToolbar"
                        :init="reqInit"
                        placeholder="Course Requirements"
                    ></editor>
                    <br>



                    <v-row>
                        <v-col cols="12" md="6">

                            <v-file-input
                                v-model="form.preview_image"
                                label="Course Preview Image"
                                prepend-icon="mdi-camera"
                                outlined
                                class=""
                                dense
                                :error-messages="$page.props.errors.preview_image"
                                accept="image/png, image/jpeg, image/bmp"
                                persistent-hint
                                :rules="[value => !value || value.size < 2000000 || 'Preview Image size should be less than 2 MB!',]"
                                hint="Only .jpg or .png are allowed"
                            />

                            <img
                                :src="previewFile(form.preview_image)"
                                height="150px"
                                class="ml-10 img-thumbnail"
                                alt=""
                            />
                        </v-col>

                        <v-col cols="12" md="6">
                           <div class="d-flex">
                               <v-switch
                                   inset
                                   label="Is Course Featured?"
                                   v-model="form.is_featured"
                                   :true-value="1"
                                   :false-value="0"
                                   color="success"
                                   class="mx-2"
                               />

                               <v-switch
                                   inset
                                   label="Is Course Published?"
                                   v-model="form.is_published"
                                   :true-value="1"
                                   :false-value="0"
                                   color="success"
                                   class="mx-2"
                               />
                           </div>

                            <v-switch
                                  inset
                                  label="Is Course Priced?"
                                  v-model="form.is_priced"
                                  :true-value="1"
                                  :false-value="0"
                                  color="success"
                                  class="mx-2"
                                />

                                <v-text-field
                                  outlined
                                  dense
                                  v-model="form.price"
                                  label="Enter Price"
                                  v-show="form.is_priced"
                                  type="number"
                                />

                                <v-switch
                                  v-show="form.is_priced"
                                  inset
                                  label="Is Discounted?"
                                  v-model="form.is_discounted"
                                  :true-value="1"
                                  :false-value="0"
                                  color="success"
                                  class="mx-2"
                                />

                                <v-text-field
                                  outlined
                                  dense
                                  v-model="form.discount_price"
                                  label="Enter Discount Price"
                                  v-show="form.is_priced && form.is_discounted"
                                  type="number"
                                />
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider/>
                <v-card-actions >
                    <v-spacer/>
                    <v-btn
                        type="submit"
                        class="mx-1 menu-btn elevation-0 white--text success"
                        color="success"
                        dark
                        :loading="form.processing"
                    >
                        Save Course
                    </v-btn>
                </v-card-actions>
            </v-card>
        </form>
    </div>
</template>


<script>

 import AdminLayout from "../AdminLayout";

import Editor from '@tinymce/tinymce-vue'
import '../../tinymce/tinymce.min'
import '../../tinymce/themes/silver/theme.min'
import '../../tinymce/skins/ui/oxide/skin.min.css'
import '../../tinymce/skins/ui/oxide/content.min.css'
import '../../tinymce/skins/content/default/content.min.css'
import '../../tinymce/icons/default/icons.min'
import '../../tinymce/plugins/lists/plugin.min'
import '../../tinymce/plugins/link/plugin.min'
import '../../tinymce/plugins/paste/plugin.min'
import '../../tinymce/plugins/help/plugin.min'
import '../../tinymce/plugins/wordcount/plugin.min'

export default {
    name: "Create",
    layout:AdminLayout,

    components:{
        Editor
    },
    data() {
        return{

            form: this.$inertia.form({
                id:null,
                title:null,
                slug:null,
                preview_text:null,
                preview_image:'/storage/courses/default.png',
                is_priced:0,
                price:null,
                is_discounted:0,
                discount_price:null,
                is_featured:0,
                is_published:0,
                category_id:null,
                sub_category_id:null,
                child_category_id:null,
                details:null,
                requirement:null,
                targeted_profession:null,
                preview_video:null,
                start_date:null,
                end_date:null,
            }),

            myToolbar: 'undo redo | formatselect | bold italic backcolor | \\\n' +
                '           alignleft aligncenter alignright alignjustify | \\\n' +
                '           bullist numlist outdent indent | removeformat | help',
            myPlugins: "lists link paste  help wordcount",
            myInit: {
                height:400,
                menubar: false ,
            },


            reqToolbar: 'bullist numlist',
            reqPlugins: "lists",
            reqInit: {
                height:300,
                menubar: false ,
            },
        }
    },

    created(){

        if(this.$page.props.course){

            let course = this.$page.props.course

                this.form.id               = course.id
                this.form.title            = course.title
                this.form.preview_text     = course.preview_text
                this.form.preview_image    = course.preview_image
                this.form.is_priced        = course.is_priced
                this.form.price            = course.price
                this.form.is_discounted    = course.is_discounted
                this.form.discount_price   = course.discount_price
                this.form.is_featured      = course.is_featured
                this.form.is_published     = course.is_published
                this.form.category_id       = course.category_id
                this.form.sub_category_id   = course.sub_category_id
                this.form.child_category_id = course.child_category_id
                this.form.details           = course.details
                this.form.requirement       = course.requirement
                this.form.start_date        = course.start_date
                this.form.end_date          = course.end_date
        }
    },

    methods:{
        saveCourse(){

            this.dialog = true
            this.form.post(route('admin.courses.store') )
        },
    }
}
</script>
